import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})
@Injectable({
  providedIn: 'root'
})
export class DateFormatPipe implements PipeTransform {

  transform(date, format?:string) : any {
    switch(format) {
      case 'USA': 
      return this.toAmericanDateStandardfromYYYY(date);
      case 'CANADA': 
      return this.toCanadianDateStandardfromYYYY(date);
      default:
      console.error("Pipe failed to convert date");
      return date;
    }
  }

  public toAmericanDateStandardfromYYYY(datestr) {
    if (datestr && datestr.length >= 19) {
        let year = (datestr).slice(0, 4);
        let month = (datestr).slice(5, 7);
        let day = (datestr).slice(8, 10);
        let time = (datestr).slice(11, 16);
        let hour = Number((datestr).slice(11, 13))
        if (!isNaN(hour)) {
            let ampm = hour >= 12 ? 'PM' : 'AM';
            if (hour > 12) {
                hour -= 12;
            }
            if (hour === 0) {
                hour = 12;
            }
            time = hour + (datestr).slice(13, 16);
            return month + "/" + day + "/" + year + "," + " " + time + ' ' + ampm;
        } else {
            return "";
        }
    } else if (datestr && datestr.length >= 10) {
        let year = (datestr).slice(2, 4);
        let month = (datestr).slice(5, 7);
        let day = (datestr).slice(8, 10);
        return parseInt(month) + "/" + parseInt(day) + "/" + year;
    } else {
        return "";
    }

}

//Add Canadian Date Function
toCanadianDateStandardfromYYYY(datestr) {
  if (datestr && datestr.length >= 19) {
      let year = (datestr).slice(0, 4);
      let month = (datestr).slice(5, 7);
      let day = (datestr).slice(8, 10);
      let time = (datestr).slice(11, 16);
      //am or pm
      let hour = Number((datestr).slice(11, 13))
      if (!isNaN(hour)) {
          return year + "/" + month + "/" + day + "," + " " + time;
      } else {
          return "";
      }
  } else if (datestr && datestr.length >= 10) {
      let year = (datestr).slice(0, 4);
      let month = (datestr).slice(5, 7);
      let day = (datestr).slice(8, 10);
      return year + "/" + month + "/" + day;
  } else {
      return "";
  }
}

}
